<template>
  <div>
    <el-form ref="form" size="small" :model="formData" :rules="rules">
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_amzStore') || '店铺'"
            prop="storeCode"
          >
            <dict-select
              :value="storeItem"
              :placeholder="$l('form_placeholder_amzStore') || '请选择店铺'"
              url="/ecom/amz/store/select"
              :options="{ label: 'label', value: 'this' }"
              filterable
              clearable
              @change="storeChange"
              size="small"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item :label="$l('form_label_region') || '市场'">
            <el-input
              v-model="formData.regionName"
              :placeholder="$l('form_placeholder_amzStore') || '请选择店铺'"
              readonly
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row class="mt-1">
        <SkuTable :tableData="skuTableData" ref="skuTable" @del="onDel">
          <template v-slot:header>
            <div class="d-flex mt-2">
              <div class="side-frame-success">
                <span style="font-size: 14px; color: #606266">
                  {{ $l('table_header_put_shelves_sku') || '上架SKU' }}
                </span>
                <el-divider direction="vertical"></el-divider>
                <el-button
                  size="mini"
                  type="primary"
                  plain
                  @click="chooseAmzSkuVisible = true"
                >
                  {{ $l('btn_put_shelves_sku') || '选择上架SKU' }}
                </el-button>
              </div>
            </div>
          </template>
        </SkuTable>
      </el-row>
    </el-form>
    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button @click="close()" size="small">
          {{ $l('INDEX.btn_no_save') || '不保存' }}
        </el-button>
        <el-button @click="save()" type="primary" size="small">
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>

    <ChooseAmzSku
      :visible.sync="chooseAmzSkuVisible"
      :amzSkuStatus="['Y']"
      multiple
      confirm-on-close
      reserve
      @confirm="chooseAmzSkuConfirm"
    />
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import SkuTable from './sku-table'
import ChooseAmzSku from '@/views/ecom/components/choose-amz-sku'
export default {
  mixins: [EditLoading],
  components: { SkuTable, ChooseAmzSku },
  data() {
    return {
      formData: {},
      backDialogVisible: false,
      chooseAmzSkuVisible: false,
      skuTableData: [],
      rules: {
        storeCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
      },
    }
  },
  computed: {
    storeItem() {
      const {
        regionCode,
        regionName,
        storeCode: value,
        storeName: label,
      } = this.formData
      return { regionCode, regionName, value, label }
    },
  },
  methods: {
    storeChange(e) {
      const { regionCode, regionName, value: storeCode, label: storeName } = e
      this.formData = {
        ...this.formData,
        regionCode,
        regionName,
        storeCode,
        storeName,
      }
    },
    chooseAmzSkuConfirm(data) {
      if (!data || !data.length) return
      data = data.map((item) => {
        const { amzSkuNo, goodsNameEn, goodsName, brandCode, brandName } = item
        return {
          ...item,
          amzSkuNo,
          amzGoodsSkuNo: amzSkuNo,
          asinCode: '',
          fnskuCode: '',
          salesPrice: 0,
          salesCurrencyUnit: '',
          operateCode: '',
          brandCode,
          brandCodeText: brandName,
          salesGoodsName: goodsNameEn || goodsName,
          salesTitle: goodsNameEn || goodsName,
          fbaDeliveryFee: 0,
          salesUrl: '',
          salesDesc: '',
          upc: '',
        }
      })
      this.skuTableData.push(...data)
    },
    async validate() {
      const formResult = await validate.formValidate([this.$refs.form])
      const skuResult = await this.$refs.skuTable.validate()
      return formResult && skuResult
    },
    async putShelves(checked = true) {
      if (!(await this.validate())) return (this.backDialogVisible = false)

      const listSku = this.$refs.skuTable.getTableData()
      const params = { ...this.formData, listSku, checked }
      this.loadingOpen()
      const res = await this.$api
        .ecomAmzSkuPutShelvesApi(params)
        .catch(() => null)
      this.loadingClose()

      const { status, msg } = res || {}
      if (status === 203) {
        const confirm = await this.$confirm(`<span style="color: red;">${msg}</span> &nbsp;是否要继续保存？`,
          this.$l('INDEX.label_completeDesc') || '确认信息',
          {
            confirmButtonText: this.$l('INDEX.btn_save') || '保存',
            cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
            type: 'warning',
            dangerouslyUseHTMLString: true
          }
        )
        .then(() => true)
        .catch(() => false)
        if (!confirm) return
        await this.putShelves(false)
        return
      }
      if (status !== 200) {
        this.$message.error(this.$l('tips_put_shelves_failed') || '上架失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('tips_put_shelves_success') || '上架成功！',
        type: 'success',
      })
      this.close()
      this.$emit('reload')
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
    onDel(row, index) {
      this.skuTableData.splice(index, 1)
    }
  },
}
</script>
<style lang="scss" scoped>
.side-frame-success {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin-top: 3px;
  display: flex;
  align-items: center;
}
</style>
